import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { IdPropType } from '../../../proptypes/basic';
import { FRANCHISE_URL_RESOURCE} from '../../api/resources';
import { useDialog } from '../../dialogs/components/DialogContext';
import { destroyFranchiseUrl } from '../franchiseUrlsSlice';
import { useCanDelete, useCanWrite, useCanCreate } from '../../abilities/hooks';
import CreateResourceIconButton from '../../table/components/resource/CreateResourceIconButton';
import ResourceTable from '../../table/components/resource/ResourceTable';
import { useResourceDialog } from '../../dialogs/hooks';
import Card from '@material-ui/core/Card';
import { CardHeader } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';

const initialOrderBy = [['url', 'desc']];

const columns = [
    {
        key: 'url',
        label: 'URL'
    },
];


const FranchiseUrls = ({locationId, disabled }) => {
    const canDeleteFranchiseUrl = useCanDelete(FRANCHISE_URL_RESOURCE);
    const canCreateFranchiseUrl = useCanCreate(FRANCHISE_URL_RESOURCE);
    const canWriteFranchiseUrl = useCanWrite(FRANCHISE_URL_RESOURCE);

    const dispatch = useDispatch();
    const listId = `location.${locationId}.FranchiseUrls`;
    const { openFranchiseUrlDialog } = useDialog();

    const handleCreate = useResourceDialog(FRANCHISE_URL_RESOURCE, { locationId });

    const handleEditDisabled = useCallback(
        () => disabled || !canWriteFranchiseUrl,
        [disabled, canWriteFranchiseUrl]
    );
    const handleDeleteDisabled = useCallback(
        () => disabled || !canDeleteFranchiseUrl,
        [disabled, canDeleteFranchiseUrl]
    );

    const handleEdit = useCallback(
        (franchiseUrlId) => openFranchiseUrlDialog({ locationId, franchiseUrlId }),
        [locationId, openFranchiseUrlDialog]
    );

    const handleDelete = useCallback(
        (franchiseUrlId) => dispatch(destroyFranchiseUrl({ id: franchiseUrlId })),
        [dispatch]
    );
    const fetchParams = useMemo(() => ({ limit: 15, locationId }), [locationId]);

    return (
        <Card data-cy="card-franchiseUrls" variant="outlined">
            <CardHeader
                title="Franchisepartner Webseiten"
                action={
                    <CreateResourceIconButton
                        listId={listId}
                        resource={FRANCHISE_URL_RESOURCE}
                        onClick={handleCreate}
                        color="primary"
                    />
                }
            />
            <CardContent>
                <ResourceTable
                    resource={FRANCHISE_URL_RESOURCE}
                    columns={columns}
                    listId={listId}
                    onDelete={canDeleteFranchiseUrl?handleDelete:null}
                    fetchParams={fetchParams}
                    initialOrderBy={initialOrderBy}
                    onEdit={handleEdit}
                    editDisabled={handleEditDisabled}
                    deleteDisabled={handleDeleteDisabled}
                    addingDisabled={disabled || !canCreateFranchiseUrl}
                    autoload
                />
            </CardContent>
        </Card>
    );
};

FranchiseUrls.propTypes = {
    locationId: IdPropType.isRequired,
};

FranchiseUrls.defaultProps = {};

export default FranchiseUrls;